 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780253044075_COVER from '@/components/text/9780253044075_Cover'
 import TEXT9780253044075_HALFTITLE from '@/components/text/9780253044075_Halftitle'
 import TEXT9780253044075_FRONTMATTER_1 from '@/components/text/9780253044075_Frontmatter_1'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780253044075_TITLEPAGE from '@/components/text/9780253044075_Titlepage'
 import TEXT9780253044075_COPYRIGHT from '@/components/text/9780253044075_Copyright'
 import TEXT9780253044075_CONTENTS from '@/components/text/9780253044075_Contents'
 import TEXT9780253044075_ACKNOWLEDGMENTS from '@/components/text/9780253044075_Acknowledgments'
 import TEXT9780253044075_NAMING from '@/components/text/9780253044075_Naming'
 import TEXT9780253044075_HALFTITLE_1 from '@/components/text/9780253044075_Halftitle_1'
 import TEXT9780253044075_INTRODUCTION from '@/components/text/9780253044075_Introduction'
 import TEXT9780253044075_CHAPTER_1 from '@/components/text/9780253044075_Chapter_1'
 import TEXT9780253044075_CHAPTER_2 from '@/components/text/9780253044075_Chapter_2'
 import TEXT9780253044075_CHAPTER_3 from '@/components/text/9780253044075_Chapter_3'
 import TEXT9780253044075_CHAPTER_4 from '@/components/text/9780253044075_Chapter_4'
 import TEXT9780253044075_CHAPTER_5 from '@/components/text/9780253044075_Chapter_5'
 import TEXT9780253044075_CHAPTER_6 from '@/components/text/9780253044075_Chapter_6'
 import TEXT9780253044075_CHAPTER_7 from '@/components/text/9780253044075_Chapter_7'
 import TEXT9780253044075_CHAPTER_8 from '@/components/text/9780253044075_Chapter_8'
 import TEXT9780253044075_CHAPTER_9 from '@/components/text/9780253044075_Chapter_9'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780253044075_POSTLUDE from '@/components/text/9780253044075_Postlude'
 import TEXT9780253044075_APPENDIX from '@/components/text/9780253044075_Appendix'
 import TEXT9780253044075_BIBLIOGRAPHY from '@/components/text/9780253044075_Bibliography'
 import TEXT9780253044075_INDEX from '@/components/text/9780253044075_Index'
 import TEXT9780253044075_ABOUT_THE_AUTHOR from '@/components/text/9780253044075_About_the_Author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9780253044075_Contents",
 			"name" : "text/9780253044075_Contents",
 			"component" : TEXT9780253044075_CONTENTS
 		},
 		{
 			"path" : "/text/9780253044075_Acknowledgments",
 			"name" : "text/9780253044075_Acknowledgments",
 			"component" : TEXT9780253044075_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/text/9780253044075_Naming",
 			"name" : "text/9780253044075_Naming",
 			"component" : TEXT9780253044075_NAMING
 		},
 		{
 			"path" : "/text/9780253044075_Halftitle_1",
 			"name" : "text/9780253044075_Halftitle_1",
 			"component" : TEXT9780253044075_HALFTITLE_1
 		},
 		{
 			"path" : "/text/9780253044075_Introduction",
 			"name" : "text/9780253044075_Introduction",
 			"component" : TEXT9780253044075_INTRODUCTION
 		},
 		{
 			"path" : "/text/9780253044075_Chapter_1",
 			"name" : "text/9780253044075_Chapter_1",
 			"component" : TEXT9780253044075_CHAPTER_1
 		},
 		{
 			"path" : "/text/9780253044075_Chapter_2",
 			"name" : "text/9780253044075_Chapter_2",
 			"component" : TEXT9780253044075_CHAPTER_2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js